import { createSelector, createFeatureSelector } from '@ngrx/store';

import {StoreModel} from "@interfaces/IStoreModel";
import {ICampaignUrlsState} from "@models/iCampaignUrlsState";

export const campaignURLsSelector = createFeatureSelector<StoreModel<ICampaignUrlsState>>('campaignUrls');
export const campaignURLsSelectorStore = createSelector(campaignURLsSelector, (state: StoreModel<ICampaignUrlsState>) => state);
export const campaignURLsEventSelector = createSelector(campaignURLsSelector, (state: any) => state.action);
